import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { useKiotFieldSurfaceTheme } from '../../../theme/useKiotFieldSurfaceTheme'
import { FieldSurfaceProvider, useFieldSurfaceContext } from './FieldSurfaceContext'
import type { FieldSurface } from './fieldSurfaces/types'

type FieldSurfaceThemeProviderProps = {
  surface: FieldSurface
  children: React.ReactNode
}

/**
 * Bọc vùng field — theme MUI + context surface (`form` | `filterToolbar` | `filterSidebar` | `pos` | `posUnderline`).
 * Cùng surface đã có provider thật thì không bọc ThemeProvider lần nữa (tránh createTheme chồng).
 */
export function FieldSurfaceThemeProvider({ surface, children }: FieldSurfaceThemeProviderProps) {
  const current = useFieldSurfaceContext()
  const theme = useKiotFieldSurfaceTheme(surface)

  if (current === surface) {
    return <>{children}</>
  }

  return (
    <FieldSurfaceProvider surface={surface}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </FieldSurfaceProvider>
  )
}

export default FieldSurfaceThemeProvider
